var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companiesQR"},[_c('ul',_vm._l((_vm.jobs),function(company){return _c('li',{key:company.id},[_c('h3',[_vm._v(_vm._s(company.title))]),_c('img',{attrs:{"src":company.qr,"alt":"","srcset":""}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }